import { useGenerateFileDownloadUrlMutation } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

import { ContentDispositionType } from './useFiles';
import { useNotification } from './useNotification';

export const useFilesDownload = (): {
  downloadFile: (
    file: { id: string; name?: string | null },
    contentDisposition: ContentDispositionType,
    windowReference: Window | null,
  ) => Promise<void>;
} => {
  const notify = useNotification();
  const { t } = useTranslation();
  const [getDownloadUrl] = useGenerateFileDownloadUrlMutation();

  const downloadFile = async (
    file: { id: string; name?: string | null },
    contentDisposition: ContentDispositionType,
    windowReference: Window | null,
  ) => {
    const resp = await getDownloadUrl({
      onError: () => {
        notify({ message: t('products:uploadedDocument.downloadError'), type: 'error' });
      },
      variables: {
        contentDisposition: `${contentDisposition}; filename*=UTF-8''${encodeURIComponent(file.name ?? 'file.pdf')}`,
        fileId: file.id,
      },
    });

    if (resp.data?.generateFileDownloadUrl) {
      fetch(resp.data.generateFileDownloadUrl, {
        method: 'GET',
      })
        .then((response: { url: string }) => {
          windowReference?.location.assign(response.url);
        })
        .catch(() => {
          windowReference?.close();
          notify({ message: t('products:uploadedDocument.downloadError'), type: 'error' });
        });
    }
  };
  return { downloadFile };
};
